import React from "react";
import { overlayStyles } from "./overlayStyles";
import { Box } from "@mui/material";

const Overlay = () => {
  return <Box sx={overlayStyles.overlay} />;
};

export default Overlay;
